export type RealmType = 'sandbox' | 'live' | 'integrated' | 'unknown';

export function getRealmTypeForRealmName(realmName: string | undefined): RealmType {
  switch (realmName?.toLowerCase()) {
    case 'sandbox':
    case 'sand':
      return 'sandbox';
    case 'live':
    case 'prod':
    case 'production':
      return 'live';
    case 'uat':
    case 'staging':
    case 'stage':
    case 'test':
    case 'testing':
    case 'integrated':
    case 'intg':
      return 'integrated';
    default:
      return 'unknown';
  }
}
